<template>
  <div class="login">
    <div class="login-img">
      <span><img :src="require(`@/assets/logo/xuchang2.png`)" alt=""> </span>
    </div>
    <div class="login-form">
      <div v-if="isShow == false">
        <!-- <img
          :src="require(`@/assets/dto/dto-login2.png`)"
          alt=""
          class="toQrCode"
        > -->
        <div class="denglu">
          登录
        </div>
        <!-- <div class="denglu">登录</div> -->

        <el-form
          ref="info"
          :model="info"
          :rules="systemInfo.obj.rules"
          status-icon
          label-position="left"
          label-width="0px"
        >
          <el-form-item prop="user_name">
            <el-input
              v-model="info.user_name"
              type="text"
              prefix-icon="el-icon-user"
              auto-complete="off"
              placeholder="请输入您的账号"
              clearable
            />
          </el-form-item>
          <!-- <el-form-item prop="phone">
              <el-input
                v-model.trim="info.phone"
                type="text"
                auto-complete="off"
                placeholder="请输入您的手机号"
                clearable
                @focus="handleFocus"
                @blur="handleBlur"
                @change="handleChange"
                clearable
              ></el-input>
            </el-form-item> -->
          <el-form-item prop="password">
            <el-input
              v-model="info.password"
              type="text"
              auto-complete="off"
              prefix-icon="el-icon-lock"
              placeholder="请输入您的密码"
              clearable
              show-password
            />
          </el-form-item>
          <el-form-item class="btn4">
            <el-input
              v-model.trim="info.captcha"
              type="smsCheck"
              auto-complete="off"
              placeholder="请输入您的验证码"
              clearable
            />
            <el-button type="text">
              <img :src="imgUrl" alt="" @click="handleCheckImg">
            </el-button>
          </el-form-item>
          <!-- <el-form-item prop="code" class="btn4">
              <el-input
                v-model.trim="info.code"
                type="smsCheck"
                auto-complete="off"
                placeholder="请输入您的验证码"
                clearable
              />
              <el-button
                :disabled="info.phone.length != 11 || isSendCode"
                class="btn3"
                @click="getVerificationCode"
              >
                {{ codeText }}
              </el-button>
            </el-form-item> -->
          <el-button
            type="primary"
            class="btn1"
            :loading="logining"
            @click="handleSubmit"
          >
            立即登录
          </el-button>
          <el-checkbox v-model="remember">
            记住密码
          </el-checkbox>
          <el-form-item class="other">
            <div>
              学校<span class="zhuce" @click="handleRegester">申请</span>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <img
          :src="require(`@/assets/dto/dto-login1.png`)"
          alt=""
          class="toQrCode"
          @click="to222form"
        >
        <iframe
          :src="urltest"
          frameborder="0"
          width="100%"
          height="400px"
          scrolling="auto"
        />
      </div>
    </div>
  </div>
</template>

<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>
<script>
import api from "@/api/app";
import mock from "@/utils/mock";
import { setTokenExp } from "@/utils/auth";

export default {
  components: {},
  data() {
    return {
      isShow: false,
      dialogVisible: false,
      urltest: "",
      systemInfo: mock.system.login.viewInfo,
      systemInit: mock.system.login.init,
      logining: false,
      isSendCode: false,
      codeText: "获取验证码",
      imgUrl: null,
      info: {
        user_name: "",
        password:"",
        captcha: "",
        // phone: "",
        key: "",
      },
      rules:{
         user_name: [
            { required: true, message: '请输入账号', trigger: 'blur' }
          ],
         password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
         captcha: [
            { required: true, message: '请输入验证码', trigger: 'blur' }
          ],
      },
      info1: {
        user_name: null,
        // phone: "",
        captcha: null,
        key: null,
      },
      isFocus: false,
      remember:true
    };
  },
  created() {
    if (this.$route.query.token && this.$route.query.expires_in) {
      setTokenExp(this.$route.query.token, this.$route.query.expires_in);
      let obj = {};
      obj.token = this.$route.query.token;
      api.mine.retrieve.dto(obj).then((v) => {
        localStorage.setItem("user", JSON.stringify(v.data));
        this.$store.commit("user/setUser", v.data);
        this.$router.push({ path: "/" });
      });
    }
    this.handleCheckImg();
    let _this = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        _this.$route.path === "/login" ? _this.handleSubmit() : "";
        // todo:存在隐患 怎么在document.onkeydown 获取到vue对象
        // console.log(e, "this.info");
      }
    };
  },
  watch:{
    'info.user_name':{
      handler(val){
        if(val||val===0){
            let obj = localStorage.getItem('accountObj')||null
            if(obj){
              this.info.password = JSON.parse(obj)[val]||''
            }else{
            this.info.password=''
          }
        }
      },
      deep:true
    }
  },
  mounted() {},

  methods: {
    handleChange() {
      this.isFocus = true;
    },
    handleBlur() {
      this.isFocus = false;
    },
    handleFocus() {
      console.log("handleFocus");
      this.isFocus = true;
    },
    handleRegester() {
      this.$router.push({
        path: "/apply",
      });
    },
    to222form() {
      this.isShow = false;
    },
    toQrCode() {
      this.isShow = true;
      this.handleWxLogin();
    },
    handleWxLogin() {
      this.dialogVisible = true;
      // let obj = await this.systemInit.handleWxLogin();
      let obj1 = {};
      obj1.type = 2;
      api.system.wx(obj1).then((res) => {
        let APPID = res.data.appid;
        let REDIRECT_URI = res.data.redirect_uri;
        let STATE = res.data.state;
        this.urltest = `https://open.weixin.qq.com/connect/qrconnect?appid=${APPID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_login&state=${STATE}#wechat_redirect`;
        var obj = new WxLogin({
          self_redirect: false,
          id: "login_container",
          appid: APPID,
          scope: "snsapi_login",
          redirect_uri: REDIRECT_URI,
          state: STATE,
          style: "black",
        });
      });
    },
    async handleCheckImg() {
      let obj = await this.systemInit.handleCheckImg();
      console.log(obj)
      this.imgUrl = obj.img;
      this.info.key = obj.key;
    },
    getVerificationCode() {
      this.info1.user_name = this.info.user_name;
      // this.info1.phone = this.info.phone;
      if (this.info1.captcha) {
        api.system.sendSms(this.info1).then(() => {
          this.$message({
            message: "验证码已发送",
            type: "success",
          });
          this.countDown(60);
        });
      } else {
        this.$message({
          message: "请正确填写图片验证码",
          type: "error",
        });
      }
    },
    countDown(time) {
      if (time === 0) {
        this.isSendCode = false;
        this.codeText = "获取验证码";
        return;
      } else {
        this.isSendCode = true;
        this.codeText = "重新发送(" + time + ")";
        time--;
      }
      setTimeout(() => {
        this.countDown(time);
      }, 1000);
    },
    async handleSubmit() {
      this.$refs.info.validate((valid) => {
          if (valid) {
            api.system.loginpwd(this.info).then((res) => {
            if(this.remember){
              let account={
              }
              account[String(this.info.user_name)]=this.info.password
              let accountObj =JSON.parse(localStorage.getItem('accountObj'))
              if(accountObj){
                Object.assign(accountObj,account)
                localStorage.setItem('accountObj',JSON.stringify(accountObj))
              }else{
                localStorage.setItem('accountObj',JSON.stringify(account))
              }
            }
              this.$message({
                message: "登录成功",
                type: "success",
                duration:1500
              });
              setTokenExp(res.data.token, res.data.expires_in);
              this.logining = true;
              api.mine.retrieve.dto({ token: res.data.token }).then((v) => {
                // setTimeout(() => {

                // }, 300);
                localStorage.setItem("user", JSON.stringify(v.data));
                  this.$store.commit("user/setUser", v.data);
                  this.$router.push({ path: "/" });
                  this.logining = false;
              });
            }).catch(()=>{
              this.handleCheckImg()
            })
          } else {
            return false;
          }
        })
    },
    handleRoute(v) {
      this.$router.push(v);
    },
  },
};
</script>

<style scoped lang="scss">
/deep/.el-input__prefix{
  color:$xr-color-primary;

}

.toQrCode {
  position: absolute;
  right: 0;
  top: 0;
  border-top-right-radius: 30px;
}
.btn3 {
  border-radius: 30px !important;
  color: #5282f0;
  border-color: #5282f0;
}
.btn1 {
  width: 216px;
  height: 53px;
  margin: 7% 19%;
  margin-top: 7%;
  background-image: linear-gradient(24deg, #5f8cf4 0%, #5181ef 100%),
    linear-gradient(#2eae3d, #2eae3d);
  background-blend-mode: normal, normal;
  box-shadow: 0px 10px 19px 2px rgba(82, 130, 240, 0.24);
  border-radius: 26px;
  border: 0;
  color: #ffffff;
  font-family: "Adobe Heiti Std";
  font-size: 18px;
  text-align: center;
}
.login {
  display: flex;
  overflow: hidden;
  height: 100%;
  width: 100%;
  background: url("../../../assets/bg/bg-system1.png") no-repeat;
  background-size: 100% 100%;
  min-width: $xr-min-width;
  &-img {
    width: 50%;
    height: 100%;
    padding: 2.46% 0 0 3.8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }
  &-form {
    // width: 50%;
    width: 500px;
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > div {
      // height: 68%;
      min-height: 498px;
      width: 500px;
      @include fun-layout(2);
      // padding: 9% 7% 6.7% 6.7%;
      padding: 50px;
      border-radius: 30px;
      position: relative;
      > div {
        &:nth-child(2) {
          font-size: 22px;
          color: #5282f0;
          margin-bottom: 20px;
          font-weight: bold;
          font-family: "Microsoft Ya Hei";
        }
      }
      .other {
        text-align: center;
        margin-top: 7%;
        > div > div:nth-child(1) {
          font-family: Adobe HeitiStd;
          font-size: 16px;
          color: #888888;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.login-form /deep/.el-form-item {
  margin-bottom: 28px;
}
/deep/.el-input__prefix .el-input__icon{
  font-size: 18px;
  font-weight: bold;
}
/deep/.el-input{
  font-size: 16px;
}
.login-form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0;
  width: 100%;
  height: 55px;
  @include fun-border(0, "bottom");
}
.btn4 /deep/ .el-form-item__content {
  display: flex;
  > div {
    width: 66%;
    margin-right: 4%;
  }
  button {
    padding: 0;
    width: 30%;
    border-radius: 6px;
    img {
      height: 55px;
      width: 100%;
    }
  }
}
.zhuce {
  color: #2f82ff;
  cursor: pointer;
}
.login-form /deep/ .el-form-item__error {
  left: 15px;
}
.btn3 /deep/ .el-button:focus,
.el-button:hover {
  background-color: #ecf5ff;
}
.login-form /deep/.el-form {
  width: 350px;
  height: 410px;
}
.denglu{
  font-size: 20px;
  font-weight: bold;
  color: #2f82ff;
  margin-bottom: 30px;
}
</style>
